<template>
  <v-container grid-list-xs container md-6>
    <v-row no-gutters justify="center">
      <v-col cols="12">
        <GeneradorCampos
          :key="refrescar"
          :schema="schema"
          v-model="aFormData"
          :bSubdominioTemporal="bSubdominioTemporal"
          :bDeshabilitado="bDeshabilitado"
          class="pb-10">
        </GeneradorCampos>
      </v-col>
    </v-row>
    <v-row v-if="bActivarBotones" no-gutters justify="center" align="center" class="mb-10 mt-n8">
      <v-col cols="6" xs="6" sm="4" md="4" lg="6" justify="center" align="center">
        <v-btn @click="save" large dark color="primary" class="btn-primary btn-rounded" :disabled="disabledGuardar">
           Guardar <v-icon size="20" right>mdi-cloud-download-outline </v-icon> </v-btn>
      </v-col>  
      <v-col cols="6" xs="6" sm="4" md="4" lg="6" justify="center" align="center">
        <v-btn @click="cancelar" large dark color="primary" class="btn-primary btn-rounded">
           Cancelar <v-icon size="20" right>mdi-close</v-icon></v-btn>
      </v-col>  
    </v-row>
    <v-dialog ref="confirmarSalida"
      v-model="ConfirmarSalida"
      persistent
      max-width="300">
      <v-card>
        <v-card-title class="text-h6"> Estas seguro de Cancelar? </v-card-title>
        <v-card-text> Perdera toda la información !! </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ConfirmarSalida = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="salir" >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog ref="mostrarErrores"
      v-model="mostrarErrores"
      persistent
      max-width="300">
      <v-card>
        <v-card-title class="text-h6">Advertencia! </v-card-title>
        <v-card-text> Falta diligenciar los siguientes campos obligatorios: </v-card-text>
        <v-list-item v-for="(error, index) in aErrores" :key="index">
          <v-list-item-content class="my-0">
            <v-list-item-title  v-html="error"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="mostrarErrores = false" >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  </template>
  
  <script>
  import DinamicosUtils from '@/Utlidades/DinamicosUtils.js'
  import axiosServices from '@/services/axiosServices.js'
  import GPSLocation from '@/Utlidades/GPSlocation.js'
  import HoraFecha from "@/Utlidades/Hora_Fecha.js"
  import GeneradorCampos from '@/components/dinamicos/GeneradorCampos.vue'
  
  export default {
    name:'Dinamicos',
    props: {
      aSchema: {
        type: Array,
        default: () => [],
      },
      bActivarBotones : {
        type: Boolean,
        default: true
      },
      idFormulario : {
        type: String,
        default: ''
      },
      aData: {
        type: Array,
        default: () => [],
      },
      bSubdominioTemporal:{       // Indica que se activa puente con subdominio temporal y debo pasar el param de pueste
        type: Boolean,             
        default: false            
      },
      bDeshabilitado:{
        type: Boolean,             
        default: false 
      },
  
    },
    components: {
      GeneradorCampos
    },
    data() {
      return {
        schema: [],   
        aFormData: this.aData,          // esta variable se usa para ser llenada con cada campo en generadorCampos.
        ConfirmarSalida : false,
        mostrarErrores : false,
        aErrores: [],
        oLocation : {},
        aFotos : [],           // Arreglo para guardar las fotos o firmas que toca enviar -- se debe blanquear antes de llamar PreparaDataSend
        refrescar : 0,
        disabledGuardar : false,
  
      }
    },
    async mounted () {
      // limpio el aModificaA
      if(this.aData.length === 0)  await this.$store.dispatch("dinamicos/clearModificaA")
      this.schema = await this.aSchema
      this.refrescar++
      
  
    },
  
    methods: {
      async save() {
        this.disabledGuardar = true
        // se debe validar los obligatorios
        if(!this.validarObligatorios()){
        this.disabledGuardar = false
         return
        }
  
        // const sParams = `app=PWA`
  
        const oBody = this.getBody(false)
  
        await axiosServices.postConfiguration('/formularios-dinamicos', oBody, true )
        
        this.sendFotos()
  
  
        this.disabledGuardar = false
  
        // se esta operando como componente solo por eso debe salir de una
        this.salir() 
  
      },
      cancelar() {
        this.ConfirmarSalida = true
      },
      sendFotos () {
        // envio las fotos que tego guardadas en aFotos si no estoy con APP
        this.aFotos.forEach( async foto => {
          // se recorren objetos todos tienen la foto en base64, pero si es firma tienen el nombre en Firma y si es foto el nombre esta en NombreFoto
          if(('NombreFoto' in foto)){
            axiosServices.postFoto(`Foto_${foto.NombreFoto}`, foto.Base64)
          }
          if(('Firma' in foto)){
            axiosServices.postFoto(`${foto.Firma}`, foto.Base64)
          }
        })
      },
      async getBody(bConfoto){
        // generar el envio -- separando las fotos y preparando el resto.
        // console.log('getbody dinamicos', bConfoto)
        this.aFotos = []     // lo Blanqueo fotos antes de procesar a data
  
        this.oLocation = await GPSLocation.getCurrentPosition()
        return {
          app : "ActivityFormulario",
          accion : "RegistroFormulario_Dinamico",
          Proyecto : this.PreparaDataSend(this.aFormData, bConfoto),
          idFormulario : this.idFormulario,
          Latitud : this.oLocation.coords.latitude,
          Longitud : this.oLocation.coords.longitude,
          Fecha : HoraFecha.getNow(),
        }
      },
      salir () {
        this.aFormData = []
        this.$router.replace('/ListaDinamicos')
      },
      PreparaDataSend(aDataSinFormato, bConfoto = false){
        // en esta funcion se prepara la data para el envio lo dejo como un metodo por que un Computado se ejecuta con cada cambio del aFormData
        let  aData = []     // la inicializo en blanco
  
        // console.log('PrepararDataSendInicio', aDataSinFormato )
  
        aDataSinFormato.forEach( elemento => {
          // 1. Quitar el base 64 de las fotos(3) y de las firmas(12)
          if( elemento != undefined){
  
            if(!bConfoto){   
              if((elemento.TipoPregunta == "3") || (elemento.TipoPregunta == "12")){
                // abro Detalle y quito el Base64
                for(const indexFoto in elemento.Detalle){
                  this.aFotos.push({...elemento.Detalle[indexFoto]})
                  delete elemento.Detalle[indexFoto].Base64
                }
              } 
            }
            //2. Si es un Item invoco recursivamente a esta misma funcion 6
            // console.log('Dinamicos prepararDataSend', elemento)
            if(elemento.TipoPregunta == "6"){
              elemento.Detalle.forEach( (subformulario) => {     // tengo un arreglo por eso lo recorreo
                for(const indexSubformulario in subformulario) {  // aqui tengo un objeto con varios objetos enumeroados del 0 en adelante.. Por eso recorreo de esta forma
                  if(!bConfoto){   
                    if( ( subformulario[indexSubformulario].TipoPregunta == "3") || ( subformulario[indexSubformulario] == "12") ){  // Elmino lo que requiero 
                      for(let indexFotosub in subformulario[indexSubformulario].Detalle){
                        this.aFotos.push({...subformulario[indexSubformulario].Detalle[indexFotosub]})
                        delete subformulario[indexSubformulario].Detalle[indexFotosub].Base64   // Borro directo  
                      }
                    }
                  }  
                }
              })
            }
            aData.push(elemento)
          }
        })
        // console.log('PrepararDataSendFinal', aData)
  
  
        return aData
      },
      validarObligatorios(){  // esta funsion no la puedo volver una utiliadad porque debo alterar variables de este componente.
        // valida los campos obligatorios se regresa 
        // el que sabe quienes son obligatorios es el esquema el cual se recorre y se compara con la respuesta
        
        this.aErrores = []   // limpio par iniciar
  
        this.schema.forEach( (campo, index) => {
          if(campo.Obligatorio == "1"){
            const infoCampo =  DinamicosUtils.getInfo_aData(this.aFormData, campo.idFORM_DINAMICOS_Preguntas)
  
            // de acuerdo al tipo valido si esta diligenciado por valor o textorespuesta o Detalle
            if((infoCampo == undefined) &&  (campo.idFORM_DINAMICOS_Tipos_campos != '13' && campo.idFORM_DINAMICOS_Tipos_campos != '15')){
              // El campo no esta ni diligenciado se marca como error de una 
              this.schema[index].error = true
              this.aErrores.push(campo.Pregunta)
              return
            } else {
              this.schema[index].error = false
            }
            switch (campo.idFORM_DINAMICOS_Tipos_campos) {
    
              case '3':  // Foto
              case '4':  // Multiselect
              case '12': // Firma
                // por Detalle es un array por lo cual length > 0
                if(infoCampo.Detalle.length == 0){ 
                  this.schema[index].error = true
                }
  
              break;
              case '5':  // Checkboox 
                // por valor ValorRespuesta  pero no hago nada por que si es obligatorio se llena por defaul en 0
                 this.schema[index].error = false
              break;
              case '13':  // Informacion
              case '15':  // Imagen
                 this.schema[index].error = false
              break;
              default:
                // por TextoRespusta
                if(infoCampo.TextoRespuesta == '' ){
                  this.schema[index].error = true
                }
              break;
            }
          }
        })
  
        if(this.aErrores.length >0 ){
          this.mostrarErrores = true
          return false
        } else {
          return true
        }
  
      },
  
    },
    computed: {
    },
    watch: {
        aFormData: {
          handler(){
            this.$emit('change')
          },
          deep: true
        }
      },
  
  }
  </script>
  
  <style lang="scss" scoped>
  .v-progress-circular {
    margin: 1rem;
  }
  </style>